import { serverUrl, serverUrl1, TencentUrl, TencentKey } from './config'
import fetchJsonp from 'fetch-jsonp'
import { message } from 'antd'
import { func } from 'prop-types'
import React from 'react'

if (process.env.REACT_APP_ENV === "mock") {
  // import静态加载，不能在if()中被执行
  require('../mock/index.js')
}
// 该文件里的函数仅负责处理网络请求 不带有任何业务逻辑相关的方法
/**
 * 该文件中所有函数的参数中均有三个回调函数 它们的含义如下
 * @param  {Function} success  获取信息成功的回调函数
 * @param  {Function} failure  获取信息失败的回调函数
 * @param  {Function} complete 获取信息完成(无论成功或失败)的回调函数
 */

export function loginFetchHandler(
  userID,
  password,
  success,
  failure,
  complete
) {
  fetch(serverUrl + '/user/signIn', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      passport: userID,
      password: password,
    }),
  }).then(function (response) {
    if (response.ok) {
      response.json().then((data) => {
        success && success(data)
      })
    } else {
      response.json().then((err) => {
        failure && failure(err)
      })
    }
    complete && complete()
  })
}

//发送邮箱验证码
export function sendEmailCodeFetchHandler(
  email,
  type,
  success,
  failure,
  complete
) {
  fetch(serverUrl + '/user/sendEmailCode', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email: email,
      type: type,
    }),
  }).then((response) => {
    if (response.ok) {
      success && success()
    } else {
      response.json().then((err) => {
        failure && failure(err)
      })
    }
    complete && complete()
  })
}

//邮箱登录
export function loginByEmailFetchHandler(
  email,
  code,
  success,
  failure,
  complete
) {
  fetch(serverUrl + '/user/signInByEmailCode', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email: email,
      code: code,
    }),
  }).then((response) => {
    if (response.ok) {
      response.json().then((data) => {
        success && success(data)
      })
    } else {
      response.json().then((data) => {
        failure && failure(data)
      })
    }
    complete && complete()
  })
}
//发送手机验证码
export function sendPhoneFetchHandler(phone, type, success, failure, complete) {
  fetch(serverUrl + '/user/sendSmsCode', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      phone: phone,
      type: type,
    }),
  }).then((response) => {
    if (response.ok) {
      success && success()
    } else {
      response.json().then((data) => {
        failure && failure(data)
      })
    }
    complete && complete()
  })
}
//手机登录
export function loginByPhoneFetchHandler(
  phone,
  code,
  success,
  failure,
  complete
) {
  fetch(serverUrl + '/user/signInByPhoneCode', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      phone: phone,
      code: code,
    }),
  }).then((response) => {
    if (response.ok) {
      response.json().then((data) => {
        success && success(data)
      })
    } else {
      response.json().then((err) => {
        failure && failure(err)
      })
    }
    complete && complete()
  })
}

export function registerFetchHandler(userID, password, success) {
  fetch(serverUrl + '/user', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      password: password,
      username: userID,
    }),
  }).then((response) => {
    if (response.ok) {
      response.json().then((data) => {
        success && success()
      })
    }
  })
}
export function logoutFetchHandler(success, failure, complete) {
  fetch(serverUrl + '/user/signOut', {
    method: 'PUT',
    credentials: 'include',
  }).then((res) => {
    if (res.ok) {
      res.text().then((data) => {
        console.log('注销成功！')
        success && success()
      })
    } else {
      res.json().then((data) => {
        failure && failure(data)
      })
    }
    complete && complete()
  })
}

//通过用户信息进行鉴权
export function getCurrentFetchHandler(success, failure, complete) {
  fetch(serverUrl + '/user', {
    method: 'GET',
    credentials: 'include',
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    } else {
      res.text().then((data) => {
        failure && failure(data)
      })
    }
    complete && complete()
  })
}

export function createGroupFetchHandler(
  groupname,
  groupemail,
  grouplocation,
  success
) {
  fetch(serverUrl + '/group', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      groupName: groupname,
      groupEmail: groupemail,
      groupLocation: grouplocation,
    }),
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    }
  })
}

export function getGroupFetchHandler(success, failure, complete) {
  fetch(serverUrl + '/group', {
    method: 'GET',
    credentials: 'include',
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    } else {
      failure && failure()
    }
    complete && complete()
  })
}

export function updateGroupFetchHandler(body, success, failure, complete) {
  fetch(`${serverUrl}/group/update`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    } else {
      failure && failure()
    }
    complete && complete()
  })
}

export function getCanByIdFetchHandler(canID, success, failure, complete) {
  fetch(serverUrl + '/v1/sensors/' + canID, {
    method: 'GET',
    credentials: 'include',
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    } else {
      res.json().then((err) => {
        failure && failure(err)
      })
    }
    complete && complete()
  })
}

/**
 * data返回 {Boolean flag}
 */
export function usernameDuplicateFetchHandler(
  username,
  success,
  failure,
  complete
) {
  fetch(serverUrl + `/user/username/duplicate?username=${username}`, {
    method: 'GET',
    credentials: 'include',
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    }
    complete && complete()
  })
}

/**
 * data返回 {Boolean flag} 若重复为true 若不重复为false
 */
export function contactInfoDuplicateFetchHandler(contactInfo, success) {
  fetch(serverUrl + `/user/phone/duplicate?phone=${contactInfo}`, {
    method: 'GET',
    credentials: 'include',
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    }
  })
}

export function getNewCansByGroupFetchHandler(success, failure, complete) {
  return fetch(serverUrl + '/group/newCans', {
    credentials: 'include',
  })
}

export function getAllCansByGroupFetchHandler() {
  return fetch(serverUrl + '/group/cans', {
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}

export function addCanNameFetchHandler(
  canId,
  name,
  success,
  failure,
  complete
) {
  fetch(serverUrl + '/can', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: canId,
      serial_number: name,
    }),
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    }
    complete && complete()
  })
}

export function getUserNameByIdFetchHandler(
  userId,
  success,
  failure,
  complete
) {
  fetch(serverUrl + `/public/user?id=${userId}`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
      complete && complete()
    } else {
      failure && failure()
    }
  })
}
//获取故障设备
export function getFaultEquipmentByGroupFetchHandler(
  page,
  size,
  type,
  success,
  failure,
  complete
) {
  fetch(
    serverUrl + `/repair/monitoring?page=${page}&size=${size}&type=${type}`,
    {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  ).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    } else {
      res.json().then((err) => {
        failure && failure(err)
      })
    }
    complete && complete()
  })
}

//获取错误类型的数量
export function getCanTypeNumFetchHandler(success, failure) {
  fetch(serverUrl + '/repair/total', {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    }
  })
}
//获取单个故障设备桶信息
export function getCanInfoFetchHandler(
  canId,
  page,
  size,
  success,
  failure,
  complete
) {
  fetch(serverUrl + '/repair/' + canId + '?page=' + page + '&size=' + size, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    }
    complete && complete()
  })
}
//解决单独的报错
export function resolveCanReasonFetchHandler(
  canId,
  repairType,
  time,
  success,
  failure
) {
  fetch(serverUrl + '/repair/fix', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      canId: canId,
      repairType: repairType,
      time: time,
    }),
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    }
  })
}
// //删除已经解决的垃圾桶信息
// export function deleteFaultEquipmentFetchHandler(canId, success, failure) {
//   fetch(serverUrl + `/repair/remove`, {
//     method: 'POST',
//     credentials: 'include',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({
//       canId: canId,
//     }),
//   }).then((res) => {
//     if (res.ok) {
//       success && success()
//     } else {
//       failure && failure()
//     }
//   })
// }

//获取垃圾量图的数据
export function getThermodynamicFetchHandler(success, failure, complete) {
  fetch(serverUrl + '/thermodynamicChart/map', {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    }
    complete && complete()
  })
}
// // 修改CLEANER的区域
// export function setCleanerAreaFetchHandler(userId, district, success, failure) {
//   fetch(serverUrl + '/cleaner/updateDistrict', {
//     method: 'POST',
//     credentials: 'include',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({
//       userId: userId,
//       district: district,
//     }),
//   }).then((res) => {
//     if (res.ok) {
//       success && success()
//     }
//   })
// }
//单个获取CLEANER的工作区域
export function getCleanerFetchHandler(userId, success, failure) {
  fetch(serverUrl + '/cleaner/getDistrict', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      userId: userId,
    }),
  }).then((res) => {
    if (res.ok) {
      res.text().then((data) => {
        success && success(data)
      })
    }
  })
}
//环卫员工界面个人数据
export function getItemCleanerInfoHandler(id) {
  return fetch(serverUrl + '/cleaner/getCleanerWorkInfo', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      userId: id,
    }),
  })
}
//获取环卫员工的今日已清运数据
export function getCleanerCountFetchHandler(userId) {
  return fetch(serverUrl + '/cleaner/getWorkData', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      userId: userId,
    }),
  })
}

export function getTestData(page, size, end, id = null, start = 0) {
  return fetch(serverUrl + '/test', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      page: page,
      size: size,
      id: id,
      start: start,
      end: end,
    }),
  })
}

//批量分配垃圾桶
export function setTrashCanBatchFetchHandler(id, arr, success, failure) {
  fetch(serverUrl + '/v1/sensors/assign', {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      supervisorId: id,
      ids: arr,
    }),
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    }
  })
}
//注册辖区
export function registerAreaFetchHandler(
  district,
  name,
  username,
  password,
  cleaners,
  cars,
  success,
  failure,
  complete
) {
  fetch(serverUrl + '/admin', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      district: district,
      name: name,
      username: username,
      password: password,
      cleanersNumber: cleaners,
      carsNumber: cars,
    }),
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success()
      } else {
        failure && failure(data)
      }
      complete && complete()
    })
  })
}
//注册小组
export function registerCleanerFetchHandler(
  district,
  name,
  supervisorId,
  username,
  password,
  car,
  success,
  failure,
  complete
) {
  fetch(serverUrl + '/cleaner', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      district: district,
      name: name,
      supervisorId: supervisorId,
      username: username,
      password: password,
      carCapacity: car,
    }),
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success()
      } else {
        failure && failure(data)
      }
      complete && complete()
    })
  })
}
//获取辖区参数
export function getAreaFetchHandler(userId) {
  return fetch(serverUrl + '/group/getUserAndRoleInfoByUserId/' + userId, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}
//编辑辖区
export function editAreaFetchHandler(
  userId,
  district,
  name,
  cleaners,
  cars,
  success,
  failure,
  complete
) {
  fetch(serverUrl + '/admin/' + userId, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      district: district,
      name: name,
      cleanersNumber: cleaners,
      carsNumber: cars,
    }),
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        failure && failure(data)
      }
      complete && complete()
    })
  })
}
//获取小组信息
export function getCleanerInfoFetchHandler(userId) {
  return fetch(serverUrl + '/group/getUserAndRoleInfoByUserId/' + userId, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}
//编辑小组
export function editCleanerFetchHandler(
  userId,
  district,
  name,
  car,
  success,
  failure,
  complete
) {
  fetch(serverUrl + '/cleaner/' + userId, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      district: district,
      name: name,
      carCapacity: car,
    }),
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        failure && failure(data)
      }
      complete()
    })
  })
}
//删除admin角色（直接删除该账号）
export function deleteAdminUserFetchHandler(id, success, fail) {
  fetch(serverUrl + '/admin/' + id, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success()
      } else {
        fail && fail(data)
      }
    })
  })
}
//删除cleaner角色
export function deleteCleanerUserFetchHandler(id, success, fail) {
  fetch(serverUrl + '/cleaner/' + id, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success()
      } else {
        fail && fail(data)
      }
    })
  })
}
//获取需要提醒的桶的信息
export function getNeedRemindFetchHandler(success, failure) {
  fetch(serverUrl + '/group/reminder', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
    .then((res) => {
      if (res.ok) {
        res.json().then((data) => {
          success && success(data)
        })
      }
    })
    .catch((err) => {
      failure && failure(err)
    })
}
//单个设置已提醒
export function setCansAlreadyNotice(arr, success) {
  fetch(serverUrl + '/group/reminderIgnore', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(arr),
  }).then((res) => {
    success && success()
  })
}
//修改密码
export function modifyPasswordFetchHandler(
  password,
  newPassword,
  success,
  failure,
  complete
) {
  fetch(serverUrl + '/user/updatePassword', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      password: password,
      newPassword: newPassword,
    }),
  }).then((res) => {
      if (res.ok) {
        success && success()
      } else {
        res.json().then((data)=>{
          failure &&failure(data)
        })
      }
      complete && complete()
    })
}
//发送手机验证码
export function sendPhoneVerficationCodeFetchHandler(phone) {
  return fetch(serverUrl + '/user/sendSmsCode', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      phone: phone,
      type: 'BIND',
    }),
  })
}
//绑定手机
export function bindPhoneFetchHandler(phone, code) {
  return fetch(serverUrl + '/wechat/bindPhone', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      phone: phone,
      code: code,
    }),
  })
}
//解绑手机
export function removePhoneBindFetchHandler(success, failure, complete) {
  fetch(serverUrl + '/wechat/removePhone', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }).then((res) => {
    if (res.ok) {
      success && success()
    } else {
      failure && failure()
    }
    complete && complete()
  })
}
//获取当前用户下总清运量
export function getCurrentUserTotalclearance() {
  return fetch(serverUrl + '/address/allClearance', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}
//获取行政区域的清运信息
export function getAreaCleanerceInfoFetchHandler(searchStr) {
  return fetch(serverUrl + '/address/clearanceKilograms?' + searchStr, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}
//曲线图 获取行政区域的清运信息
export function newGetAreaCleanerceInfoFetchHandler(searchStr) {
  return fetch(serverUrl + '/regions/clearanceKilograms?' + searchStr, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}
//数据明细中点击input筛选当前数据
export function dateDetailsGetAreaCleanerceInfo(searchStr) {
  return fetch(serverUrl + '/v1/regions/clearanceKilograms?' + searchStr, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}


//获取地理位置信息
export function getAddressInfoFetchHandler() {
  return fetch(serverUrl + '/address', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}
//获取清运人员的工作信息
export function getCleanerWorkInfoFetchHandler(str) {
  return fetch(serverUrl + '/address/cleaners?' + str, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}
//获取区域内的设备信息
export function getAreaEquipmentInfoFetchHandler(str) {
  return fetch(serverUrl + '/address/cans?' + str, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}
//创建Excel
export function createExcelFetchHandler(obj) {
  return fetch(serverUrl + '/address/createExcel', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(obj),
  })
}
//判断excel是否存在
export function getIsExistExcel(params) {
  return fetch(serverUrl + '/address/isExistExcel/' + params, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}
//下载Excel
export function downloadExcel(params) {
  window.open(serverUrl + '/address/exportExcel/' + params, '_self')
}
//路径规划部分
export function setPointFetchHandler(id, obj) {
  return fetch(serverUrl + '/cleaner/setPoint?userId=' + id, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(obj),
  })
}
export function getNewPathFetchHandler(obj) {
  return fetch(serverUrl + '/planPath', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(obj),
  })
}
export function getPlannedPathFetchHandler(userId, time) {
  //历史路径
  return fetch(serverUrl + `/plannedPath/${userId}/${time}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}
export function getCleanerPathFetchHandler(userId, time) {
  return fetch(serverUrl + `/clearancePath/${userId}/${time}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}
//获取admin区域信息
export function getAdminAreaInfo() {
  return fetch(serverUrl + '/admin/region', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}
// 规格管理部分获取桶信息
export function getSpecificationManagementCans(str) {
  return fetch(serverUrl + '/v1/sensors/spec?' + str, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}
/*
  修改设备信息

*/
export function modifySpecManagementCansFetchHandler(
  arr,
  specId,
  success,
  fail,
  complete
) {
  fetch(serverUrl + '/spec/cans', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      canIds: arr,
      specId: specId,
    }),
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success()
      } else {
        fail()
      }
      complete()
    })
  })
}
//规格管理新增规格
/*
  spec 规格名称	
  innerHeight 安装高度
  height 满箱高度
  capacity 满箱重量（kg） 
  type 箱体类型
*/
export function addNewSpecification(
  spec,
  innerHeight,
  height,
  capacity,
  type,
  success,
  fail,
  complete
) {
  fetch(serverUrl + '/spec', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      spec: spec,
      innerHeight: innerHeight,
      height: height,
      capacity: capacity,
      type: type,
    }),
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        fail && fail(data)
      }
      complete && complete()
    })
  })
}
/*
  获取单个规格
*/
export function getSomeOneSpecFetchHandler(specId) {
  return fetch(serverUrl + `/v1/specs/${specId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}
/*
  查询批量规格 -1规格  234规格包
*/
export function getAllSpecFetchHandler(success, fail, complete) {
  fetch(serverUrl + `/v1/specs`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        fail && fail(data)
      }
      complete && complete()
    })
  })
}
//获取当前全部清运人员信息
export function getAllAdminFetchHandler() {
  return fetch(serverUrl + '/group/allCleaners', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}
// 获取当前全部清运人员信息
export function getAllAdminFetchCallback(success) {
  fetch(serverUrl + '/group/allCleaners', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success(data)
      })
    }
  })
}
/*
  修改规格并修改设备信息
*/
export function modifySpecAndCanFetchHandler(obj) {
  return fetch(serverUrl + '/spec', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(obj),
  })
}
/*
  删除规格或规格包
*/
export function deleteSpecFetchHandler(id, success, fail) {
  fetch(serverUrl + `/v1/specs/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    } else {
      res.json().then((err) => {
        fail && fail(err)
      })
    }
  })
}
// 新增规格包
export function addSpecPackageHandler(spec, subSpecs, success, fail, complete) {
  fetch(serverUrl + '/v1/specs/package', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      spec: spec,
      subSpecs: subSpecs,
    }),
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        fail && fail(data)
      }
      complete && complete()
    })
  })
}

// 修改规格包
export function editSpecPackageHandler(
  id,
  spec,
  subSpecs,
  success,
  fail,
  complete
) {
  fetch(serverUrl + `/v1/specs/${id}/package`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      spec: spec,
      subSpecs: subSpecs,
    }),
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        fail && fail(data)
      }
      complete && complete()
    })
  })
}
// 修改单个设备
export function modifyEquipmentById(id, params, success, fail, complete) {
  fetch(serverUrl + `/v1/sensors/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(params),
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        fail && fail(data)
      }
      complete && complete()
    })
  })
}
//查询微信小程序屏蔽关系
export function getWeChatBindInfo(userId) {
  return fetch(serverUrl + '/wechat/bindInfos/' + userId, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}
//修改微信服务号提醒,修改绑定小程序屏蔽关系
export function setWeChatRemindStateHandler(id, obj, success, fail) {
  fetch(serverUrl + '/wechat/bindInfos/' + id, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(obj),
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    } else {
      res.json().then((err) => {
        fail && fail(err)
      })
    }
  })
}
//修改手机号邮箱提醒  + 强提醒部分
export function setPhoneEmailStateHandler(id, obj, success, fail) {
  fetch(serverUrl + '/user/' + id, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(obj),
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        fail && fail(data)
      }
    })
  })
}
//解绑小程序
export function untieWeChatFetchHandler(unionId, success, fail) {
  fetch(serverUrl + '/wechat/' + unionId, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        fail && fail(data)
      }
    })
  })
}
//解绑手机
export function untiePhoneFetchHandler(id, phone, success, fail) {
  fetch(serverUrl + '/user/' + id + '/phone', {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      phone: phone,
    }),
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        fail && fail(data)
      }
    })
  })
}
//解绑邮箱
export function untieEmailFetchHandler(id, email, success, fail) {
  fetch(serverUrl + '/user/' + id + '/email', {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      email: email,
    }),
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        fail && fail(data)
      }
    })
  })
}

// TODO: TencentUrl下的接口无法mock
//输入提示腾讯
export function getInputPromptFetchHandler(keyword, lng, lat, success, fail) {
  fetchJsonp(
    TencentUrl +
      '/ws/place/v1/suggestion?key=' +
      TencentKey +
      '&keyword=' +
      keyword +
      '&location=' +
      lat +
      ',' +
      lng +
      '&output=jsonp'
  )
    .then((res) => res.json())
    .then((data) => {
      if (data.data) {
        success && success(data)
      }
    })
    .catch((err) => {
      console.log(err)
    })
}
//腾讯逆地址解析
export function getReversegeocoding(lng, lat, success, fail) {
  fetchJsonp(
    TencentUrl +
      '/ws/geocoder/v1?key=' +
      TencentKey +
      '&location=' +
      lat +
      ',' +
      lng +
      '&output=jsonp'
  )
    .then((res) => res.json())
    .then((data) => {
      success && success(data)
    })
    .catch((err) => {
      console.log(err)
    })
}
//腾讯路径规划
export function getPathPlanFetchHandler(
  startStr,
  endStr,
  wayPoints,
  success,
  fail
) {
  fetchJsonp(
    TencentUrl +
      '/ws/direction/v1/driving?key=' +
      TencentKey +
      '&from=' +
      startStr +
      '&to=' +
      endStr +
      '&waypoints=' +
      wayPoints +
      '&output=jsonp'
  )
    .then((res) => res.json())
    .then((data) => {
      success && success(data)
    })
    .catch((err) => {
      console.log(err)
    })
}
//新接口(获取当前用户的桶信息)
export function getCansByCurrentUser(success) {
  fetch(serverUrl1 + '/can/getPercentage', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }).then((res) => {
    res.json().then((data) => {
      success && success(data)
    })
  })
}
//获取日周月数据
export function getChoseCanDataFetchHandler(canId, type, success, failure) {
  fetch(serverUrl1 + '/can/statistics', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      canId: canId,
      statisticsType: type,
    }),
  }).then((res) => {
    res.json().then((data) => {
      success && success(data)
    })
  })
}

// 电量管理
// 查询设备电量-灵敏度
export function getDevicePowerHandler(str) {
  return fetch(`${serverUrl}/sensors/power${str}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}

// // 获得团队清运人员信息 和getAllAdminFetchHandler定义重复
// export function getCleanersHandler() {
//   return fetch(`${serverUrl}/group/allCleaners`, {
//     method: 'GET',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     credentials: 'include',
//   })
// }

// 更新设备灵敏度 和addCanNameFetchHandler重复定义
export function updateCanThresholdHandler(
  canId,
  threshold,
  success,
  failure,
  complete
) {
  fetch(`${serverUrl}/can`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: canId,
      threshold: threshold,
    }),
  })
    .then((res) => {
      if (res.ok) {
        res.json().then((data) => {
          success && success(data)
        })
        complete && complete()
      }
    })
    .catch((err) => {
      failure && failure(err)
      complete && complete()
    })
}

// 批量更新设备灵敏度
export function updateMultipleCanThresholdHandler(
  ids,
  threshold,
  success,
  failure,
  complete
) {
  fetch(`${serverUrl}/sensors`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ids: ids,
      threshold: threshold,
    }),
  })
    .then((res) => {
      if (res.ok) {
        res.json().then((data) => {
          success && success(data)
        })
        complete && complete()
      }
    })
    .catch((err) => {
      failure && failure(err)
      complete && complete()
    })
}

// 历史订单查询
export function getHistoricalOrders(str, success, fail, complete) {
  fetch(`${serverUrl}/pay/orders?${str}`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        fail && fail(data)
      }
      complete && complete()
    })
  })
}
// 历史订单详情查询
export function getOrderDetailById(id, success, fail, complete) {
  fetch(serverUrl + '/pay/orders/' + id, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        fail && fail(data)
      }
      complete && complete()
    })
  })
}
// 查询订单详情(带列表)
export function checkOrderDetailsById(id, success, fail, complete) {
  fetch(serverUrl + `/pay/orders/${id}/detail`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        fail && fail(data)
      }
      complete && complete()
    })
  })
}
// 取消历史订单
export function cancelHistoricalOrderById(id, success, fail, complete) {
  fetch(serverUrl + '/pay/orders/' + id, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        fail && fail(data)
      }
      complete && complete()
    })
  })
}

// 获取设备充值列表
export function getEquipmentRechargeData(str, success, fail, complete) {
  fetch(serverUrl + '/sensors/expire?' + str, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        fail && fail(data)
      }
      complete && complete()
    })
  })
}
// 自动续费开关控制
export function automaticRenewalFlag(id, autoRenewal, success, fail, complete) {
  fetch(serverUrl + `/sensors/${id}/autoRenewals`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      autoRenewal: autoRenewal,
    }),
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        fail && fail(data)
      }
      complete && complete()
    })
  })
}
// payment
// 创建订单
export function createOrder(body, success, failure, complete) {
  // 去除空值
  for (let item in body) {
    if (body[item] === '') delete body[item]
  }
  fetch(`${serverUrl}/pay/orders`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        failure && failure(data)
      }
      complete && complete()
    })
  })
}

// 查询批量型号
export function getSensorModels(success, failure, complete) {
  fetch(`${serverUrl}/sensorModels`, {
    method: 'GET',
    credentials: 'include',
  })
    .then((res) => {
      if (res.ok) {
        res.json().then((data) => {
          success && success(data)
        })
        complete && complete()
      }
    })
    .catch((err) => {
      failure && failure(err)
      complete && complete()
    })
}

// 获取账户
export function getAccountBalance(success, failure, complete) {
  fetch(`${serverUrl}/pay/account`, {
    method: 'GET',
    credentials: 'include',
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        failure && failure(data)
      }
      complete && complete()
    })
  })
}

// 开始支付
export function pushPay(id, payType, success, failure, complete) {
  fetch(`${serverUrl}/pay/orders/${id}/pay`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ payType }),
  })
    .then((res) => {
      if (res.ok) {
        res.json().then((data) => {
          success && success(data)
        })
        complete && complete()
      } else throw new Error()
    })
    .catch((err) => {
      failure && failure(err)
      complete && complete()
    })
}

// 轮训查询订单 重复定义
export function getOrderStatus(id, success, failure, complete) {
  fetch(`${serverUrl}/pay/orders/${id}`, {
    method: 'GET',
    credentials: 'include',
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        failure && failure(data)
      }
      complete && complete()
    })
  })
}

// 轮训查询订单
export function getChargeSensor(str, success, failure, complete) {
  fetch(`${serverUrl}/sensors/models?${str}`, {
    method: 'GET',
    credentials: 'include',
  })
    .then((res) => {
      if (res.ok) {
        res.json().then((data) => {
          success && success(data)
        })
        complete && complete()
      }
    })
    .catch((err) => {
      failure && failure(err)
      complete && complete()
    })
}

// 我的账户我的设备数据获取
export function getMyDevice(success, failure, complete) {
  fetch(`${serverUrl}/v1/sensors/total`, {
    method: 'GET',
    credentials: 'include',
  })
    .then((res) => {
      if (res.ok) {
        res.json().then((data) => {
          success && success(data)
        })
        complete && complete()
      }
    })
    .catch((err) => {
      failure && failure(err)
      complete && complete()
    })
}

//查询单个设备历史清运数据
export function getSingleDeviceHistoricalData(
  id,
  dateType,
  success,
  failure,
  complete
) {
  fetch(`${serverUrl}/v1/sensors/${id}/clearanceHeights?dateType=${dateType}`, {
    method: 'GET',
    credentials: 'include',
  })
    .then((res) => {
      if (res.ok) {
        res.json().then((data) => {
          success && success(data)
        })
        complete && complete()
      }
    })
    .catch((err) => {
      failure && failure(err)
      complete && complete()
    })
}

//服务账户展示
export function getCurrentRegionAndSubordinate(
  str,
  success,
  failure,
  complete
) {
  fetch(`${serverUrl}/regions/users/subordinates?` + str, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((res) => {
      if (res.ok) {
        res.json().then((data) => {
          success && success(data)
        })
        complete && complete()
      }
    })
    .catch((err) => {
      failure && failure(err)
      complete && complete()
    })
}

//获取当前用户所属公司（团队）
export function getSuperiorCompany(success, failure, complete) {
  fetch(`${serverUrl}/v1/groups`, {
    method: 'GET',
    credentials: 'include',
  })
    .then((res) => {
      if (res.ok) {
        res.json().then((data) => {
          success && success(data)
        })
        complete && complete()
      }
    })
    .catch((err) => {
      failure && failure(err)
      complete && complete()
    })
}

//获取目标行政区以及下属行政区
export function getTargetAndSubordinateDistrict(success, failure, complete) {
  fetch(`${serverUrl}/regions/subordinates`, {
    method: 'GET',
    credentials: 'include',
  })
    .then((res) => {
      if (res.ok) {
        res.json().then((data) => {
          success && success(data)
        })
        complete && complete()
      }
    })
    .catch((err) => {
      failure && failure(err)
      complete && complete()
    })
}

//大数据使用 获取目标行政区以及下属行政区
export function newGetAddressInfoFetchHandler() {
  return fetch(`${serverUrl}/regions/subordinates`,{
    method: 'GET',
    credentials: 'include',
  })
}


//导出行政区域用户信息Excel文件 
export function exportRegionAccountFile (str) {
  if(str){
    window.open(serverUrl + '/regions/users/excel/' + str)
  }else{
    window.open(serverUrl + '/regions/users/excel/')
  }
}

//创建行政区域
export function createRegionHandler(obj, success, failure, complete) {
  fetch(`${serverUrl}/regions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(obj),
  }).then(function (response) {
    if (response.ok) {
      response.json().then((data) => {
        success && success(data)
      })
    } else {
      response.json().then((err) => {
        failure && failure(err)
      })
    }
    complete && complete()
  })
}

//删除行政区
export function removeRegionHandler(id, success, failure, complete) {
  fetch(`${serverUrl}/regions/` + id, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }).then(function (response) {
    if (response.ok) {
      response.json().then((data) => {
        success && success(data)
      })
    } else {
      response.json().then((err) => {
        failure && failure(err)
      })
    }
    complete && complete()
  })
}

//修改行政区
export function modifyRegionHandler(id, obj, success, failure, complete) {
  fetch(`${serverUrl}/regions/` + id, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(obj),
  }).then(function (response) {
    if (response.ok) {
      response.json().then((data) => {
        success && success(data)
      })
    } else {
      response.json().then((err) => {
        failure && failure(err)
      })
    }
    complete && complete()
  })
}

//获取当前行政区上一级行政区域
export function getUpperDistrictInfo(id, success, failure, complete) {
  fetch(`${serverUrl}/regions/${id}/superiors`, {
    method: 'GET',
    credentials: 'include',
  })
    .then((res) => {
      if (res.ok) {
        res.json().then((data) => {
          success && success(data)
        })
        complete && complete()
      }
    })
    .catch((err) => {
      failure && failure(err)
      complete && complete()
    })
}

//创建行政区用户
export function createAccountHandler(obj, success, failure, complete) {
  fetch(serverUrl + '/regions/users', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(obj),
  }).then(function (response) {
    if (response.ok) {
      response.json().then((data) => {
        success && success(data)
      })
    } else {
      response.json().then((err) => {
        failure && failure(err)
      })
    }
    complete && complete()
  })
}

//编辑行政区用户
export function modifyAccountHandler(id, obj, success, failure, complete) {
  fetch(serverUrl + '/regions/users/' + id, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(obj),
  }).then(function (response) {
    if (response.ok) {
      response.json().then((data) => {
        success && success(data)
      })
    } else {
      response.json().then((err) => {
        failure && failure(err)
      })
    }
    complete && complete()
  })
}

//获取服务账户社区未分配箱体
export function getServiceAccountUnassignedDevice() {
  return fetch(serverUrl + '/regions/unassigned/sensors', {
    method: 'GET',
    credentials: 'include',
  })
}

//获取服务账户社区已分配箱体
export function getServiceAccountAssignedDevice(id) {
  return fetch(`${serverUrl}/regions/${id}/sensors`, {
    method: 'GET',
    credentials: 'include',
  })
}

//给服务账户社区分配或取消分配设备
export function serviceAccountAssignAndUnassignHandler(
  id,
  ids,
  success,
  failure
) {
  return fetch(`${serverUrl}/regions/${id}/sensors`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      ids: ids,
    }),
  }).then((res) => {
    if (res.ok) {
      res.json().then((data) => {
        success && success(data)
      })
    }
  })
}

//根据行政区域和时间划分清运量
export function getServiceAccountClearance(str) {
  return fetch(serverUrl + '/regions/subordinates/clearance?' + str, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}

//获取当前用户下属行政区箱体，大数据页面用
export function newGetAreaEquipmentInfoFetchHandler (id) {
  return fetch(serverUrl+'/regions/subordinates/'+id+'/sensors',
  {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}

//行政区域清运信息的Excel
export function createDistrictExcelFetchHandler(str) {
  return fetch(serverUrl + '/regions/clearance/excel?' + str, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
}

//判断excel是否存在
export function getDistrictIsExist(params) {
  return fetch(serverUrl + '/excel/exist/' + params, {
    method: 'GET',
    credentials: 'include',
  })
}

//下载Excel
export function downloadDistrictExist(params) {
  window.open(serverUrl + '/excel/export/' + params, '_self')
}

//获取账户（分级和以前的）所管理设备总清运量
export function getDeviceTotalWeightByCurrentAccount() {
  return fetch(serverUrl + '/regions/allClearance', {
    method: 'GET',
    credentials: 'include',
  })
}
// 服务账户获取区域上级
export function getAreaFathers(id, success, failure, complete) {
  fetch(serverUrl + `/regions/${id}/fathers`, {
    method: 'GET',
    credentials: 'include',
  }).then((res) => {
    res.json().then((data) => {
      if (data.code === 0) {
        success && success(data)
      } else {
        failure && failure(data)
      }
      complete && complete()
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/fetchData.js